// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2d_OT","emails":"CreateEditClinics_emails__3FSI3","emailTagLabel":"CreateEditClinics_emailTagLabel__1sdJW"};